import { render, staticRenderFns } from "./BriqTextarea.vue?vue&type=template&id=01a20fa9&scoped=true&lang=pug&"
import script from "./BriqTextarea.vue?vue&type=script&lang=js&"
export * from "./BriqTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BriqTextarea.vue?vue&type=style&index=0&id=01a20fa9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a20fa9",
  null
  
)

export default component.exports